import { DownOutlined } from '@ant-design/icons';
import { Dropdown } from 'antd';
import { useState } from 'react';

import {
  COMPOSER_MODES,
  type ComposerMode,
} from '@app/components/LeadCard/ui/MessageComposer/data/composerModes';

import type { FC } from 'react';

import './ComposerModeSelector.scss';

interface ComposerModeSelectorProps {
  selectedMode: ComposerMode;
  onModeChange(mode: ComposerMode): void;
}

export const ComposerModeSelector: FC<ComposerModeSelectorProps> = ({
  selectedMode,
  onModeChange,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const currentMode =
    COMPOSER_MODES.find(({ id }) => id === selectedMode) ?? COMPOSER_MODES[0];

  const { IconComponent: CurrentIcon } = currentMode;

  const dropdownContent = (
    <div className="ComposerModeSelector__dropdown">
      {COMPOSER_MODES.map(({ id, label, IconComponent: Icon }) => (
        <button
          key={id}
          type="button"
          className={[
            'ComposerModeSelector__option',
            id === selectedMode && 'ComposerModeSelector__option--active',
          ]
            .filter(Boolean)
            .join(' ')}
          onClick={() => {
            onModeChange(id);
            setIsOpen(false);
          }}
        >
          <Icon className="ComposerModeSelector__option-icon" />
          <span className="ComposerModeSelector__option-label">{label}</span>
        </button>
      ))}
    </div>
  );

  return (
    <Dropdown
      trigger={['click']}
      open={isOpen}
      onOpenChange={setIsOpen}
      popupRender={() => dropdownContent}
    >
      <button type="button" className="ComposerModeSelector__trigger">
        <CurrentIcon className="ComposerModeSelector__trigger-icon" />
        <span className="ComposerModeSelector__trigger-label">
          {currentMode.label}
        </span>
        <DownOutlined className="ComposerModeSelector__trigger-caret" />
      </button>
    </Dropdown>
  );
};
